module.exports = __webpack_public_path__ + "img/chinesecompany216.f1d29c40.png";